export const autoScroll = ({ element, height = 0 }) => {
  if (!element) return;

  element.scrollTop = element.scrollHeight - (height || element.clientHeight);
};
